// extracted by mini-css-extract-plugin
export default {"submittedDurationCompleteCell":"SubmittedDurationCompleteCell_submittedDurationCompleteCell__H-5AJ"};